/** Shared palette for the layer controls: dark frosted-glass panels
 * (theme.palette.primary.dark at 60% alpha) with white text and a bright
 * amber accent for "on" states, so nothing is blue-on-blue. */
export const PANEL_BG = 'rgba(0, 62, 103, 0.6)';
export const DARK_BLUE = 'rgb(0, 62, 103)';
export const WHITE = '#fff';
export const TEXT = 'rgba(255,255,255,0.92)';
export const TEXT_DIM = 'rgba(255,255,255,0.7)';
export const ACCENT = '#ffce54';
export const ACCENT_HOVER = '#ffd96b';
